<template>
    <div class="wp">
        <div class="w-1200 home-detail-1">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="breadTo">{{breadTitle}}</el-breadcrumb-item>
                        <el-breadcrumb-item>内容详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="h-d-b">
                <div class="title">
                    <p class="p1">{{detail.infoTitle}}</p>
                    <p class="p2"><span style="padding-right:10px;">发布时间</span>  {{detail.createDate}}       <span style="padding-left:50px;padding-right:10px;">发布人</span>  {{detail.fgr}}</p>
                </div>
                <com-richtext :richtext="detail.fgnr"></com-richtext>
            </div>
        </div>
    </div>
</template>
<script>
import HomeDetail from './HomeDetail.js';
export default HomeDetail;
</script>
<style lang="scss" scoped>
@import './HomeDetail.scss';
</style>